import React, {useState} from "react";
import {InventoryItem} from "./interfaces";
import {getItemDisplayName, getItemIconUrl} from "./itemResolver";

interface ItemSlotProps {
    item?: InventoryItem
}

export default function ItemSlot({item}: ItemSlotProps) {
    const [imgFailed, setImgFailed] = useState(false)

    if (!item) {
        return <div className="aspect-square bg-neutral-800 border border-neutral-700 rounded-sm"/>
    }

    const name = getItemDisplayName(item.shortname)
    const conditionPct = item.condition !== undefined && item.maxCondition
        ? Math.max(0, Math.min(1, item.condition / item.maxCondition))
        : undefined

    const tooltip = `${name}${item.amount > 1 ? ` x${item.amount}` : ""}${
        conditionPct !== undefined ? ` — ${Math.round(conditionPct * 100)}%` : ""
    }`

    return (
        <div
            className="relative aspect-square bg-neutral-800 border border-neutral-700 rounded-sm overflow-hidden group"
            title={tooltip}>
            {imgFailed ? (
                <div className="size-full flex items-center justify-center text-[10px] text-neutral-400 px-1 text-center break-all">
                    {item.shortname}
                </div>
            ) : (
                <img
                    src={getItemIconUrl(item.shortname)}
                    alt={name}
                    className="size-full object-contain p-0.5"
                    onError={() => setImgFailed(true)}
                />
            )}

            {item.amount > 1 && (
                <span className="absolute bottom-0.5 right-1 text-xs font-bold text-white drop-shadow-[0_1px_1px_rgba(0,0,0,1)]">
                    x{item.amount}
                </span>
            )}

            {conditionPct !== undefined && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-neutral-900/70">
                    <div
                        className={`h-full ${conditionPct > 0.5 ? "bg-green-500" : conditionPct > 0.2 ? "bg-yellow-500" : "bg-red-500"}`}
                        style={{width: `${conditionPct * 100}%`}}
                    />
                </div>
            )}
        </div>
    )
}
